import { render, staticRenderFns } from "./SiteGroupsPage.vue?vue&type=template&id=5ec844d6&scoped=true"
import script from "./SiteGroupsPage.vue?vue&type=script&lang=js"
export * from "./SiteGroupsPage.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SiteGroupsPage.vue?vue&type=style&index=1&id=5ec844d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec844d6",
  null
  
)

export default component.exports